const SAVING_ACCOUNT = '1'

export const onlyNumbers = value => value.replace(/[^\d]/g, '')

export const normalizeDate = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 4) {
    return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2)}`
  }
  return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 4)}/${onlyNums.slice(4, 8)}`
}

export const normalizeCPF = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3)}`
  }
  if (onlyNums.length <= 9) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}`
  }
  return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}-${onlyNums.slice(
    9,
    11
  )}`
}

export const normalizeDocument = document => {
  if (!document) {
    return document
  }
  const onlyNums = document.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3)}`
  }
  if (onlyNums.length <= 9) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}`
  }

  if (onlyNums.length < 12) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(
      6,
      9
    )}-${onlyNums.slice(9, 11)}`
  }

  if (onlyNums.length < 13) {
    return `${onlyNums.slice(0, 2)}.${onlyNums.slice(2, 5)}.${onlyNums.slice(
      5,
      8
    )}/${onlyNums.slice(8, 12)}`
  }

  return `${onlyNums.slice(0, 2)}.${onlyNums.slice(2, 5)}.${onlyNums.slice(5, 8)}/${onlyNums.slice(
    8,
    12
  )}-${onlyNums.slice(12, 14)}`
}

export const normalizeCNPJ = cnpj => {
  if (!cnpj) return ''

  cnpj = cnpj.replace(/[^\d]/g, '')

  if (cnpj.length < 3) return cnpj

  if (cnpj.length === 3) return `${cnpj.slice(0, 2)}.${cnpj.slice(2)}`

  if (cnpj.length < 6) return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}`

  if (cnpj.length < 9) return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}`

  if (cnpj.length < 13)
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}`

  return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(
    8,
    12
  )}-${cnpj.slice(12, 14)}`
}

export const normalizeCRP = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length < 3) {
    return onlyNums
  }
  if (onlyNums.length <= 4) {
    return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 4)}`
  }
  return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 20)}`
}

export const normalizeCEP = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')

  if (onlyNums.length <= 5) {
    return onlyNums
  }
  if (onlyNums.length === 6) {
    return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 6)}`
  }
  return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 8)}`
}

// (99) 9 9999-9999
export const normalizePhone = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length < 3) {
    return '(' + onlyNums.slice(0, 2)
  }
  if (onlyNums.length < 4) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 3)
  }
  if (onlyNums.length === 7) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2) + '-'
  }
  if (onlyNums.length <= 2) {
    return onlyNums
  }
  if (onlyNums.length <= 8) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2)
  }

  if (onlyNums.length === 10) {
    return (
      '(' +
      onlyNums.slice(0, 2) +
      ') ' +
      onlyNums.slice(2, 3) +
      ' ' +
      onlyNums.slice(3, 6) +
      '-' +
      onlyNums.slice(6, 10)
    )
  }
  return (
    '(' +
    onlyNums.slice(0, 2) +
    ') ' +
    onlyNums.slice(2, 3) +
    ' ' +
    onlyNums.slice(3, 7) +
    '-' +
    onlyNums.slice(7, 11)
  )
}

// 9?9?9?9?9?9?9?9?9?9?9?9?9?9?
export const normalizeInternationalPhone = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')

  return onlyNums.slice(0, 14)
}

// (99) 99999-9999
// TODO: removes this code, because it is basically the same as the normalizePhone function
export const normalizeCellPhone = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length < 3) {
    return '(' + onlyNums.slice(0, 2)
  }
  if (onlyNums.length < 4) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 3)
  }

  if (onlyNums.length <= 8) {
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2)
  }

  if (onlyNums.length === 10) {
    return (
      '(' +
      onlyNums.slice(0, 2) +
      ') ' +
      onlyNums.slice(2, 3) +
      ' ' +
      onlyNums.slice(3, 6) +
      '-' +
      onlyNums.slice(6, 10)
    )
  }
  return (
    '(' +
    onlyNums.slice(0, 2) +
    ') ' +
    onlyNums.slice(2, 3) +
    ' ' +
    onlyNums.slice(3, 7) +
    '-' +
    onlyNums.slice(7, 11)
  )
}

// 9999 9999 9999 9999
export const numberCreditCard = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')

  if (onlyNums.length <= 16) {
    return onlyNums.match(/.{1,4}/g).join(' ')
  }
}

//  mm/aa
export const overdueCreditCard = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')

  if (onlyNums.length < 3) {
    return onlyNums
  }

  if (onlyNums.length === 3) {
    return onlyNums.slice(0, 2) + '/' + onlyNums.slice(2, 3)
  }

  if (onlyNums.length < 5) {
    return onlyNums.slice(0, 2) + '/' + onlyNums.slice(2, 4)
  }
}

// 99999-D
export const bankAccount = value => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 5) {
    return onlyNums
  }

  if (onlyNums.length < 12) {
    return onlyNums.slice(0, onlyNums.length - 1) + '-' + onlyNums.slice(-1)
  }
}

// 9999-D
export const bankAgency = (value, bank) => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d|X|x]/g, '')
  if (onlyNums.length <= 4) {
    return onlyNums
  }

  if (bank !== 'Banco do Brasil' && bank !== 'Bradesco') {
    return onlyNums.slice(0, 4)
  }

  if (onlyNums.length < 6) {
    return onlyNums.slice(0, onlyNums.length - 1) + '-' + onlyNums.slice(-1)
  }
}

// 0,00
// TODO: improve this helper name, it's not intuitive at all
export const price = value => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 2) {
    return onlyNums
  }

  if (onlyNums.length > 2) {
    return onlyNums.slice(0, onlyNums.length - 2) + ',' + onlyNums.slice(-2)
  }
}

export const normalizeCurrency = value => {
  const onlyNumbers = value.replace(/\D/g, '')

  if (!onlyNumbers) {
    return '0,00'
  }

  const parsedValue = parseFloat(onlyNumbers) / 100

  return parsedValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
}

// TODO: remove the Banco Original repeated occurence
export const getLimit = (bank, account_type) => {
  switch (bank) {
    case 'Mercado Pago':
    case 'Stone':
      return 14
    case 'Caixa Econômica':
      if (account_type === SAVING_ACCOUNT) return 14
      return 12
    case 'Via Credi':
    case 'Via Credi/Civia Cooperativa':
    case 'JP Morgan':
    case 'Stark Bank':
      return 12
    case 'Sicoob':
    case 'Banrisul':
    case 'BRB':
    case 'Inter':
    case 'Modal':
    case 'Itaú':
    case 'Banpará':
    case 'Banco Pan':
    case 'Banco Safra':
    case 'Banese':
    case 'Banestes':
    case 'Bco Sofisa S.A.':
    case 'Banco Master S.A.':
    case 'Cartos SCD S.A.':
    case 'Credisan':
    case 'Crefisa':
    case 'Fibra S.A.':
    case 'HR Digital Sociedade de Crédito Direto S.A':
    case 'J17 - SCD S/A':
    case 'Letsbank S.A':
    case 'Mercantil do Brasil':
    case 'Monetarie Sociedade de Crédito Direto S.A.':
    case 'Omni':
    case 'PJBank/Dock IP S.A':
    case 'Singulare':
    case 'Superdigital I.P. S.A.':
    case 'Topazio':
    case 'Unicred':
    case 'Will Bank/Avista S.A Credito':
    case 'VORTX DTVM LTDA':
    case 'Picpay':
      return 10
    case 'Nubank':
    case 'Neon':
    case 'Votorantim':
    case 'Neon/Votorantim':
    case 'Neon Pagamentos S.A. IP':
    case 'Acesso Soluções de pagamento':
    case 'Agibank':
    case 'Rendimento':
    case 'ABC Brasil':
    case 'Banco Ribeirão Preto':
    case 'FitBank':
    case 'Juno':
    case 'Social Bank':
    case 'SRM Bank':
    case 'Stark Bank S.A. — IP':
      return 11
    case 'Banco do Brasil':
    case 'Santander':
    case 'Safra':
    case 'PagSeguro':
    case 'Pagseguro':
    case 'Citibank':
    case 'Money Plus':
    case 'Pinbank':
    case 'Banco BV S.A.':
    case 'Banco Digio S.A':
    case 'Gerencianet Pagamentos do Brasil':
    case 'PJBank':
    case 'HBI SCD':
    case 'Uy3 SCD S/A':
      return 9
    case 'Bradesco':
    case 'Bradesco/Next':
    case 'Banco Original':
    case 'C6':
    case 'Cora':
    case 'BS2':
    case 'Asaas':
    case 'Banco Daycoval':
    case 'Cooperativa Central de Credito Noroeste Brasileiro':
    case 'ID Corretora de Títulos e Valores Mobiliários S.A.':
    case 'Next':
    case 'Pefisa':
    case 'Qi Sociedade de Crédito':
    case 'XP Investimentos':
      return 8
    case 'Sicredi':
    case 'BTG Pactual':
      return 7
    case 'SUPERLOGICA SCD S.A.':
    case 'VERT DTVM LTDA':
    case 'Ótimo':
      return 6
    case 'Banco Genial':
      return 5
    default:
      return 9
  }
}

export const getAccountPlaceholder = (bank, account_type) => {
  switch (bank) {
    case 'Caixa Econômica':
      if (account_type === SAVING_ACCOUNT) return 'XXXX999999999-D'
      return 'XXX99999999-D'
    case 'Uniprime':
    case 'Banco Genial':
      return '9999-D'
    case 'Banco Topazio':
    case 'Ótimo':
    case 'Cresol':
      return '99999-D'
    case 'Banco Daycoval':
    case 'Banco do Nordeste':
    case 'Uniprime Norte do Paraná':
    case 'Banco da Amazonia':
    case 'BRL Trust DTVM':
    case 'Banco Omni':
    case 'Omni':
    case 'Polocred':
    case 'BTG Pactual':
      return '999999-D'
    case 'Banco Original':
    case 'BS2':
    case 'Bradesco':
    case 'Bradesco/Next':
    case 'Cooperativa Central de Credito Noroeste Brasileiro':
    case 'Cora':
    case 'Next':
    case 'Asaas':
    case 'BMG':
    case 'Banco Master S.A.':
    case 'Celcoin':
    case 'Cloud Walk Meios de Pagamento e Serviços Ltda':
    case 'Fibra S.A.':
    case 'Pefisa':
    case 'Qi Sociedade de Crédito':
    case 'Singulare':
    case 'Superdigital I.P. S.A.':
    case 'XP Investimentos':
      return '9999999-D'
    case 'Sicoob':
    case 'Itaú':
    case 'Banpará':
    case 'Banrisul':
    case 'Inter':
    case 'BRB':
    case 'Modal':
    case 'Banco Pan':
    case 'Banese':
    case 'Banestes':
    case 'Bco Sofisa S.A.':
    case 'Cartos SCD S.A.':
    case 'Credisan':
    case 'Crefisa':
    case 'HR Digital Sociedade de Crédito Direto S.A':
    case 'J17 - SCD S/A':
    case 'Letsbank S.A':
    case 'Mercantil do Brasil':
    case 'Monetarie Sociedade de Crédito Direto S.A.':
    case 'Topazio':
    case 'Unicred':
    case 'Will Bank/Avista S.A Credito':
    case 'Santander':
    case 'Banco Safra':
    case 'Picpay':
      return '999999999-D'
    case 'PJBank':
    case 'PJBank/Dock IP S.A':
    case 'Nubank':
    case 'Juno':
    case 'Neon':
    case 'Votorantim':
    case 'Neon/Votorantim':
    case 'Neon Pagamentos S.A. IP':
    case 'ABC Brasil':
    case 'Banco Ribeirão Preto':
    case 'FitBank':
    case 'Mercado Pago':
    case 'Social Bank':
    case 'SRM Bank':
      return '9999999999-D'
    case 'Via Credi':
    case 'Via Credi/Civia Cooperativa':
    case 'JP Morgan':
      return '99999999999-D'
    case 'Stone':
      return '9999999999999-D'
    case 'BNP Paribas Brasil':
      return '999999-DDD'
    case 'CCR de São Miguel do Oeste':
    case 'ID Corretora de Títulos e Valores Mobiliários S.A.':
    case 'Listo SCD S.A.':
    case 'FIDUCIA SCMEPP LTDA':
      return '99999'
    case 'Sicredi':
      return '99999999D'
    case 'Banco Digio S.A':
      return '99999999-9'
    case 'Stark Bank':
      return '999999999999'
    case 'Stark Bank S.A. — IP':
      return '99999999999'
    case 'SUPERLOGICA SCD S.A.':
      return '99999-9'
    case 'Uy3 SCD S/A':
      return '99999999'
    case 'VERT DTVM LTDA':
      return '99999-D'
    case 'VORTX DTVM LTDA':
      return '99999999-D'
    case 'Citibank':
    case 'Acesso Soluções de pagamento':
    case 'Gerencianet Pagamentos do Brasil':
    case 'Money Plus':
    case 'Pagseguro':
    case 'Pinbank':
    case 'HBI SCD':
      return '99999999'
    case 'Agibank':
    case 'Rendimento':
    case 'Banco Rendimento':
      return '9999999999'
    case 'Global SCM':
      return '99999999999'
    case 'BANCO XP S.A.':
    case 'Banco XP S.A.':
    case 'PagPrime IP':
      return '9999999'
    default:
      return '99999999-D'
  }
}

export const getAgencyPlaceholder = bank => {
  switch (bank) {
    case 'Money Plus':
      return '9'
    case 'Banco do Nordeste':
    case 'BNP Paribas Brasil':
    case 'BRL Trust DTVM':
    case 'Banco Banese':
    case 'Banese':
    case 'Pinbank':
    case 'ZOOP MEIOS DE PAGAMENTO':
      return '999'
    case 'Banco Ribeirão Preto':
      return '99999'
    case 'Banco do Brasil':
    case 'Bradesco':
    case 'Bradesco/Next':
    case 'Rendimento':
    case 'Banco Rendimento':
    case 'ABC Brasil':
    case 'Next':
    case 'Cresol':
      return '9999-D'
    default:
      return '9999'
  }
}

export const normalizeBankAccount = (value, bank, account_type) => {
  const generateBankAccountRegex = () => {
    switch (bank) {
      case 'Banco do Brasil':
        return /[^\dXx]/g
      default:
        return /[^\d]/g
    }
  }

  const limit = getLimit(bank, account_type)
  const bankAccountRegex = new RegExp(generateBankAccountRegex())
  const validCharacters = value?.replace(bankAccountRegex, '').replace(/x/g, 'X') || ''

  if (bank === 'Sicredi') {
    return validCharacters.slice(0, limit)
  }

  const newValue = (validCharacters.length > 1 && validCharacters[0] === '0'
    ? validCharacters.replace(/^0+/, '')
    : validCharacters
  ).slice(-limit)

  const zeros = '0'.repeat(limit - newValue.length)
  const formattedValue = zeros + newValue

  if (formattedValue.length > 1) {
    return formattedValue.slice(0, -1) + '-' + formattedValue.slice(-1)
  } else {
    return formattedValue
  }
}
